import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  border-top: none;
  height: 35px;
`
const Table = styled.div`
  display: table;
  width: 100%;
  height: 10%;
`
const Cell = styled.div`
  display: flex;
  width: 100%;
  vertical-align: baseline;
`

const UploadingCell = styled.div`
  display: table-cell;
  width: 50%;
  vertical-align: baseline;
`
const AboutCell = styled.div`
  display: table-cell;
  width: 50%;
  vertical-align: baseline;
  text-align: right;
  padding-right: 10px;
`
const Uploading = styled.label`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9b9b9b;
  padding-right: 1px;
  @media (max-width: 468px) {
    font-size: 11px;
  }
`

const ErrorUploading = styled.label`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #cc2d30;
  padding-right: 1px;
  @media (max-width: 468px) {
    font-size: 11px;
  }
`
const About = styled.label`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #9b9b9b;
  padding-right: 10px;
  @media (max-width: 468px) {
    font-size: 11px;
  }
`

const StyledProgress = styled.progress<{ value: number; error?: { message: string } }>`
  width: 100%;
  height: 7px;
  margin-right: 20px;
  background-color: #ebebeb;
  color: ${(props) => `${props.value < 100 ? '#0071bd' : props.error ? '#cc2d30' : '#0caf51'}`};
  border: 0;
  border-radius: 9px;
  background-size: auto auto;

  &::-webkit-progress-bar {
    background-color: #f3f3f3;
    border-radius: 9px;
  }

  &::-webkit-progress-value {
    background: ${(props) => `${props.value < 100 ? '#0071bd' : props.error ?
      '#cc2d30' : '#0caf51'}`
    };
    border-radius: 9px;
  }

  &::-moz-progress-bar {
    background: ${(props) => `${props.value < 100 ? '#0071bd' : props.error ?
      '#cc2d30' : '#0caf51'}`
    };
    border-radius: 9px;
  }
  -webkit-appearance: none;
  &::-ms-fill {
    border: none;
  }
`

type ProgressBarProps = {
  progress: number
  error?: { message: string }
  timeLeft?: string
}

const ProgressBar = ({ progress, error, timeLeft }: ProgressBarProps) => (
  <Container>
    <Table>
      <Cell>
        <StyledProgress
          error={error}
          value={error === undefined ? progress : 100}
          max='100'
        />
      </Cell>
    </Table>
    {!error && progress < 100 && (
      <Table>
        <UploadingCell>
          <Uploading>Uploading ({progress}%)</Uploading>
        </UploadingCell>
        <AboutCell>
          <About>
            {timeLeft === undefined ? 'Calculating time left...' : `About ${timeLeft}`}
          </About>
        </AboutCell>
      </Table>
    )}
    {error && (
      <Table>
        <UploadingCell>
          <ErrorUploading data-testid='error-uploading'>
            {error.message === '400' ? 'Failed - Unsupported file' : 'Failed - Try again'}
          </ErrorUploading>
        </UploadingCell>
      </Table>
    )}
  </Container>
)

export { ProgressBar }
